import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { LCSelector } from 'src/app/shared/models/LCSelector';
import { StoreCurrency, StoreCurrencyVO } from 'src/app/shared/models/StoreCurrency';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { DropdownSelectorService } from 'src/app/utils/tovpil-dropdown-selector.service';
import { CountryModel } from 'src/app/shared/models/country-model';

@Component({
  selector: 'app-store-currency-adm',
  templateUrl: './store-currency-adm.component.html',
  styleUrls: ['./store-currency-adm.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class StoreCurrencyAdmComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  years: any[];
  countries: CountryModel[];

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = true;
  editingRow: StoreCurrencyVO = {
    storeCurrency: null,
    currencyOrig: null,
    currencyDest: null
  };

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetStoreCurrencies = "getAllStoreCurrency";
  endPointGetStoreById = "getStoreByIdWithDescription";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";

  endPointCreateStoreCurrency = "createStoreCurrency";
  endPointUpdateStoreCurrency = "updateStoreCurrency";
  endPointDeleteStoreCurrency = "deleteStoreCurrency";
  endPointGetOnlyCoutryFromStore = "getOnlyCoutryFromStore";

  /** ELEMENT */
  fromCurrencies: any[];
  toCurrencies: any[];
  selectedCurrencies: any[];

  currenciesStore: StoreCurrency[];
  colsGlCurrencies = ['id.storeId', 'id.year', 'id.countryId', 'id.currency', 'id.currencyDest', 'status'];

  baseCordinationCatalogList: LCSelector[] = [];
  fromCordinationCatalogList: LCSelector[] = [];
  toCordinationCatalogList: LCSelector[] = [];

  /**
  * This constructor function initializes various services and variables used in the component, and also
  * checks for authentication based on the token and device parameters passed in the URL.
  * @param {MessageService} messageService - This parameter is of type MessageService and is used for
  * displaying messages to the user. It is likely used to show success or error messages during certain
  * operations.
  * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
  * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
  * confirmation before performing certain actions.
  * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
  * making API requests and handling responses.
  * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
  * which is used to access the current route's information. It provides access to the route's
  * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
  * used to subscribe to the
  * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
  * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
  * the current user's information.
  * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
  * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
  * downloading files.
  * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
  * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
  * on data in the application.
  * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
  * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
  */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private urlBuilderService: UrlBuilderService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private dropdownSelectorService: DropdownSelectorService,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService) {

    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.guideId = params.guideId;
      this.dataParent.type = params.type;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
  * The function initializes form groups for configuration and data, and updates the configuration form
  * with query parameters from the route.
  */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    console.debug("CX3 LGC - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
  * The function `createDataForm` in TypeScript initializes a form group with various form controls and
  * default values, as well as setting some controls as disabled.
  */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: true }),
      selectedPeriod: new FormControl({ value: null, disabled: false }),
      selectedFromCurrency: new FormControl({ value: null }),
      selectedToCurrency: new FormControl({ value: null }),

      selectedBankName: new FormControl({ value: '', disabled: false }),
      selectedBankAccount: new FormControl({ value: '', disabled: false }),

      fromSelectedCoordination: new FormControl({ value: null, disabled: false }),
      toSelectedCoordination: new FormControl({ value: null, disabled: false }),
      baseSelectedCoordination: new FormControl({ value: null, disabled: false }),

      selectedCountry: new FormControl({ value: null, disabled: true }),
    });

    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    console.debug("CX3 LGC - REACTIVE FORM: " + JSON.stringify(this.globalUserDataForm.value, null, 2));
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.preferences.currentUser = currentUser;

    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences?.storeId || null;
    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
      this.globalUserPreferences.preferences.coordinationId = data?.storeId ?? null;
      this.globalUserPreferences.storeId = data?.storeId ?? null;
      this.globalUserPreferences.preferences.guideId = data?.guideId ?? null;
      this.getTranslatedLabels();

    } else {
      this.globalUserPreferences.preferences.coordinationId = securityControl;
      this.globalUserPreferences.storeId = securityControl;
      this.getTranslatedLabels();
    }
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    console.debug("CX3 LGC - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferences, null, 2));

    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();

      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    console.debug("CX3 LGC - LANGUAGES");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      const years = [...new Set(this.periods.map(period => period.year))].map(year => ({ year }));
      this.years = years;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  async getOnlyCoutryFromStore(language: string, storeId: string) {
    try {

      let req = {
        "language": language,
        "storeId": storeId
      };

      const data = await this.tovpilCrudService.fetch(this.endPointGetOnlyCoutryFromStore, req);

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstCouunties = Array.isArray(data.data) ? data.data : [data.data];
      const _selectedCountry = lstCouunties[0] ?? null;

      // Asigna los valores a las propiedades correspondientes
      this.countries = lstCouunties;
      this.globalUserDataForm.patchValue({
        selectedCountry: _selectedCountry
      })

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
    * This TypeScript function asynchronously fetches a list of currencies based on store ID and language
    * ID, handling errors and returning the data if successful.
    * @returns The function returns either the fetched currency data if
    * successful, or `null` if there are missing parameters, an error occurred during fetching, or an
    * exception was caught.
    */
  async getListFromCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        let lstCurrencies = result.data;
        let currencySelected = currency ? lstCurrencies.find(o => o.valueId === currency) ?? lstCurrencies[0] : lstCurrencies[0] ?? null;
        this.fromCurrencies = lstCurrencies;

        this.globalUserDataForm.patchValue({
          selectedFromCurrency: currencySelected
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
    * This TypeScript function asynchronously fetches a list of currencies based on store ID and language
    * ID, handling errors and returning the data if successful.
    * @returns The function returns either the fetched currency data if
    * successful, or `null` if there are missing parameters, an error occurred during fetching, or an
    * exception was caught.
    */
  async getListToCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        let lstCurrencies = result.data;
        let currencySelected = currency ? lstCurrencies.find(o => o.valueId === currency) ?? lstCurrencies[0] : lstCurrencies[0] ?? null;
        this.toCurrencies = lstCurrencies;

        this.globalUserDataForm.patchValue({
          selectedToCurrency: currencySelected
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async getListSelectedCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        this.selectedCurrencies = result.data;
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function  asynchronously updates currency lists based on store
   * ID, language, and selected currency preferences.
   */
  async updatetListCurrenciesByStoreId() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const currency = this.globalUserPreferences?.preferences?.selCurrency || null;

    const coordinationStoreId = (this.globalUserDataForm.get('baseSelectedCoordination').value)?.store?.storeId ?? this.globalUserPreferences?.preferences?.coordinationId ?? null;

    await this.getListFromCurrencyByStoreId(coordinationStoreId, language, currency);
    await this.getListToCurrencyByStoreId(coordinationStoreId, language, currency);
    await this.getOnlyCoutryFromStore(language, coordinationStoreId);
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {
      const language = this.globalUserPreferences?.preferences?.language || null;
      const coordinationStoreId = (this.globalUserDataForm.get('baseSelectedCoordination').value)?.store?.storeId ?? this.globalUserPreferences?.preferences?.coordinationId ?? null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;

      const validPeriodsResponse = await this.getValidPeriods(language);
      const validCountryResponse = await this.getOnlyCoutryFromStore(language, coordinationStoreId);

      await this.getListFromCurrencyByStoreId(coordinationStoreId, language, currency);
      await this.getListToCurrencyByStoreId(coordinationStoreId, language, currency);

      await this.initLoadBaseCoordinationSelector();
      // await this.initLoadToCoordinationSelector();
      // await this.initLoadBaseCoordinationSelector();

      if (validPeriodsResponse && validCountryResponse) {

        this.getConfigs();
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validPeriodsResponse);
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    if (!this.globalUserDataForm.valid) {
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return;
    }
    try {
      this.blocked = true;
      const salesResponse = await this.getStoreCurrencies();

      if (salesResponse) {
        console.debug("CX3 LGC - LOAD DATA: ", salesResponse);
        this.blocked = false;
      } else {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `reloadGetStoreCurrencies` asynchronously reloads a list of services, displaying an error
   * message if the operation fails.
   */
  async reloadGetStoreCurrencies() {
    try {
      this.blocked = true;
      const servsResponse = await this.getStoreCurrencies();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list serve");
        //this.messageService.add({ severity: 'warn', summary: 'REGISTRO CARGOS POR MATERIAL (E/S LOC)', detail: 'Se canceló carga de datos, inténtelo más tarde' });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list serve");
      //this.messageService.add({ severity: 'warn', summary: 'REGISTRO CARGOS POR MATERIAL (E/S LOC)', detail: 'Se canceló carga de datos, inténtelo más tarde' });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `getStoreCurrencies` is an asynchronous function that fetches a list of sales data and
   * handles success and error cases.
   * @returns a Promise object.
   */
  async getStoreCurrencies() {
    try {
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;
      const selGuideId = this.dataParent.guideId || null;

      let req = {
        year: selYear,
        period: selPeriod,
        guideId: selGuideId,
        language: selLanguage,
      };

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetStoreCurrencies, null).then(result => {
          console.debug("CX3 LGC - SERVS: ", req, result)
          if (result.success) {
            this.handleSuccessStoreCurrencies(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function "handleSuccessStoreCurrencies" handles the success response of a sales list and extracts the
   * columns dynamically from the JSON data.
   * @param {any[]} data - An array of objects containing sales data.
   */
  async handleSuccessStoreCurrencies(data: any[]) {
    if (data.length > 0) {
      try {
        this.currenciesStore = data;
      } catch (error) {
        console.error("An error occurred while processing data:", error);
        //this.handleError("Hubo un problema, no hay información que procesar en lista de servicios. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    } else {
      this.currenciesStore = null;
      //this.handleError("Hubo un problema, no hay información que procesar en lista de servicios. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  async handleError(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The function onRowEditInit() is used to initialize row editing in TypeScript.
   */
  async onRowEditInit(data: any) {
    const storeId = data['id']['storeId'] ?? null;
    const language = this.globalUserPreferences?.preferences?.language || null;
    const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
    await this.getListSelectedCurrencyByStoreId(storeId, language, currency);

    if (this.editingRow?.storeCurrency) {
      return;
    }



    this.editingRow.storeCurrency = JSON.parse(JSON.stringify(data));
    console.debug("Data: ", this.editingRow.storeCurrency);
  }


  /**
   * The function onRowEditInit() is used to initialize row editing in TypeScript.
   */
  async onRowEditSave(data: any) {
    // UPDATE
    try {
      this.blocked = true;

      // VALIDATE PREVIOUS REQUEST
      if (!this.globalUserDataForm.valid) {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
        this.editingRow.storeCurrency = null;

        return;
      }

      this.editingRow.currencyOrig = data['id']['currency'];
      this.editingRow.currencyDest = data['id']['currencyDest'];

      // CALL API TO CREATE STORE CURRENCY
      const result = await this.tovpilCrudService.fetch(this.endPointUpdateStoreCurrency, this.editingRow);

      // EVALUATE RESPONSE TO MAKE ACTION
      if (result.success) {
        this.editingRow.storeCurrency = null;

        this.blocked = false;
        this.reloadGetStoreCurrencies();
      } else {
        this.editingRow.storeCurrency = null;

        this.blocked = false;
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (e) {
      this.editingRow.storeCurrency = null;
      this.blocked = false;
      console.error(e);
    }
  }

  /**
   * The function onRowEditCancel() is used to handle the cancellation of row editing.
   */
  onRowEditCancel() {
    // NOTHING TO DO
    this.editingRow.storeCurrency = null;
  }

  /**
   * The function onRowDelete() is currently empty and needs to be implemented.
   */
  async onRowDelete(data: any) {
    try {
      this.blocked = true;

      // VALIDATE PREVIOUS REQUEST
      if (!this.globalUserDataForm.valid) {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
        return;
      }

      // CALL API TO CREATE STORE CURRENCY
      const result = await this.tovpilCrudService.fetch(this.endPointDeleteStoreCurrency, data);

      // EVALUATE RESPONSE TO MAKE ACTION
      if (result.success) {
        this.blocked = false;
        this.reloadGetStoreCurrencies();
      } else {
        this.blocked = false;
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (e) {
      this.blocked = false;
      console.error(e);
    }
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {
    try {
      window.close();
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /**
   * The exportExcel function checks if a list exists and is not empty, then maps the list items to a new
   * JSON format and exports it to an Excel file.
   */
  exportExcel() {
    let materialReqLst = this.currenciesStore || null;
    if (materialReqLst === null) {
      // Lista no existe
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else if (materialReqLst.length < 1) {
      // Lista Vacia
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else {
      const filteredJSON = materialReqLst.map((item) => ({
        "COORDINACION": item ? (item?.id?.storeId || 'S/N') : 'S/N',
        "AÑO": item ? (item?.id?.year || 'S/N') : 'S/N',
        "CIUDAD": item ? (item?.id?.countryId || 'S/N') : 'S/N',
        "MONEDA_ORIGEN": item ? (item?.id?.currency || 'S/N') : 'S/N',
        "MONEDA_DESTINO": item ? (item?.id?.currencyDest || 'S/N') : 'S/N',
        "ESTATUS": item ? (item?.status || 'S/N') : 'S/N',
      }));
      this.filesService.tovpilExportXLSX(filteredJSON, 'currencyExg_');
    }
  }

  /**
   * The `exportPdf` function checks if a list exists and is not empty, then formats the data and
   * exports it to a PDF file.
   */
  exportPdf() {
    let materialReqLst = this.currenciesStore || null;
    if (materialReqLst === null) {
      // Error de lista no existe
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else if (materialReqLst.length < 1) {
      // Error de lista vacía
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else {
      const filteredJSON = materialReqLst.map((item) => ({
        "COORDINACION": item ? (item?.id?.storeId || 'S/N') : 'S/N',
        "AÑO": item ? (item?.id?.year || 'S/N') : 'S/N',
        "CIUDAD": item ? (item?.id?.countryId || 'S/N') : 'S/N',
        "MONEDA_ORIGEN": item ? (item?.id?.currency || 'S/N') : 'S/N',
        "MONEDA_DESTINO": item ? (item?.id?.currencyDest || 'S/N') : 'S/N',
        "ESTATUS": item ? (item?.status || 'S/N') : 'S/N',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'currencyExg_');
    }
  }


  /** MANAGE PREFERENCES */

  /**
   * The function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    console.debug("CX3 RCM - ON CHANGE USER PREFERENCES: ")
    await this.refreshPreferences();

    // RECARGA
    await this.initConfigs();
    await this.getSecurity();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataForm.get('selectedPeriod').value) || null;
    let storeId = this.globalUserPreferences?.preferences?.storeId ?? null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      storeId, //_storeId
      null, //_id
      language || null, //_language
      null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  /** MIXED DROPDOWN MODULAR SELECTOR */

  /**
   * The function `initLoadFromCoordinationSelector` asynchronously initializes a dropdown selector for
   * coordination based on user data and preferences.
   */
  async initLoadFromCoordinationSelector() {
    const coordinationStoreId = (this.globalUserDataForm.get('baseSelectedCoordination').value)?.store?.storeId ?? this.globalUserPreferences?.preferences?.coordinationId ?? null;

    this.fromCordinationCatalogList = await this.dropdownSelectorService.initLoadCoordinationSelector(
      coordinationStoreId,
      this.globalUserDataForm,
      this.globalUserPreferences,
      'from',
      this.handleError.bind(this),
      this.setBlocked.bind(this)
    );
  }

  /**
   * The function `initLoadToCoordinationSelector` asynchronously initializes a coordination selector for
   * the 'to' field using data from global user data and preferences.
   */
  async initLoadToCoordinationSelector() {
    const coordinationStoreId = (this.globalUserDataForm.get('baseSelectedCoordination').value)?.store?.storeId ?? this.globalUserPreferences?.preferences?.coordinationId ?? null;

    this.toCordinationCatalogList = await this.dropdownSelectorService.initLoadCoordinationSelector(
      coordinationStoreId,
      this.globalUserDataForm,
      this.globalUserPreferences,
      'to',
      this.handleError.bind(this),
      this.setBlocked.bind(this)
    );
  }

  /**
   * The function `initLoadBaseCoordinationSelector` asynchronously initializes a coordination selector for
   * the 'to' field using data from global user data and preferences.
   */
  async initLoadBaseCoordinationSelector() {
    const coordinationStoreId = (this.globalUserDataForm.get('baseSelectedCoordination').value)?.store?.storeId ?? this.globalUserPreferences?.preferences?.coordinationId ?? null;

    console.debug("Store Base: " + coordinationStoreId);
    this.baseCordinationCatalogList = await this.dropdownSelectorService.initLoadCoordinationSelector(
      coordinationStoreId,
      this.globalUserDataForm,
      this.globalUserPreferences,
      'base',
      this.handleError.bind(this),
      this.setBlocked.bind(this)
    );
  }

  /**
   * The function `fromSelectionCoordinationCatalog` loads coordination catalogs based on the store ID
   * from a given LCSelector object.
   * @param {LCSelector} coordinationCatalog - LCSelector - an object containing information about a
   * coordination catalog, including the storeId property.
   */
  async fromSelectionCoordinationCatalog(coordinationCatalog: LCSelector) {
    const storeId = coordinationCatalog?.store?.storeId;

    if (storeId !== 'L' && storeId !== null) {
      this.fromCordinationCatalogList = await this.dropdownSelectorService.loadCoordinationCatalogs(storeId, this.globalUserDataForm, this.globalUserPreferences, 'from');
      this.updateForm('from');
    } else if (storeId !== 'L' && storeId === null) {
      console.error("Error en carga de coordinacion seleccionada: An error occurred while redirect state to JSON:");
    }
  }

  /**
   * The function `toSelectionCoordinationCatalog` checks the storeId in a given coordination catalog and
   * loads coordination catalogs accordingly.
   * @param {LCSelector} coordinationCatalog - LCSelector - an object representing a coordination catalog
   * with properties such as storeId, globalUserDataForm, and globalUserPreferences.
   */
  async toSelectionCoordinationCatalog(coordinationCatalog: LCSelector) {
    const storeId = coordinationCatalog?.store?.storeId;

    if (storeId !== 'L' && storeId !== null) {
      this.toCordinationCatalogList = await this.dropdownSelectorService.loadCoordinationCatalogs(storeId, this.globalUserDataForm, this.globalUserPreferences, 'to');
      this.updateForm('to');
    } else if (storeId !== 'L' && storeId === null) {
      console.error("Error en carga de coordinacion seleccionada: An error occurred while redirect state to JSON:");
    }
  }

  /**
   * The function `baseSelectionCoordinationCatalog` loads coordination catalogs based on the store ID
   * provided.
   * @param {LCSelector} coordinationCatalog - LCSelector - an object containing information about a
   * coordination catalog, including the store ID.
   */
  async baseSelectionCoordinationCatalog(coordinationCatalog: LCSelector) {
    const storeId = coordinationCatalog?.store?.storeId;

    if (storeId !== 'L' && storeId !== null) {
      this.baseCordinationCatalogList = await this.dropdownSelectorService.loadCoordinationCatalogs(storeId, this.globalUserDataForm, this.globalUserPreferences, 'base');
      await this.updateForm('base');

      // ACTUALIZAMOS PARA CARGAR MONEDA
      await this.updatetListCurrenciesByStoreId();

    } else if (storeId !== 'L' && storeId === null) {
      console.error("Error en carga de coordinacion seleccionada: An error occurred while redirect state to JSON:");
    }
  }

  /**
   * The function `updateForm` updates a form control based on the type provided ('from' or 'to').
   * @param {'from' | 'to'} type - The `type` parameter in the `updateForm` function can have a value of
   * either `'from'` or `'to'`. This parameter is used to determine whether to update the form for the
   * "from" or "to" section.
   */
  async updateForm(type: 'from' | 'to' | 'base') {
    const catalogList = type === 'from'
      ? this.fromCordinationCatalogList
      : type === 'to'
        ? this.toCordinationCatalogList
        : this.baseCordinationCatalogList;

    const formControlName = type === 'from'
      ? 'fromSelectedCoordination'
      : type === 'to'
        ? 'toSelectedCoordination'
        : 'baseSelectedCoordination';

    this.globalUserDataForm.patchValue({ [formControlName]: catalogList[0] ?? null });
  }

  /**
   * The function `setBlocked` in TypeScript sets the `blocked` property to a specified boolean value.
   * @param {boolean} blocked - The `blocked` parameter in the `setBlocked` function is a boolean
   * parameter that indicates whether a certain action or state is blocked or not. When `blocked` is set
   * to `true`, it typically means that the action is blocked or restricted, while setting it to `false`
   * means that the
   */
  setBlocked(blocked: boolean) {
    this.blocked = blocked;
  }

  /**
   * The function `createStoreCurrency` is an asynchronous function in TypeScript that attempts to create
   * a currency store and logs any errors to the console.
   */
  async createStoreCurrency() {
    try {
      this.blocked = true;

      // VALIDATE PREVIOUS REQUEST
      if (!this.globalUserDataForm.valid) {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
        return;
      }

      // REQUEST TO CREATE STORE CURRENCY
      let _storeId = (this.globalUserDataForm.get('baseSelectedCoordination').value)?.store?.storeId ?? null;
      let _year = (this.globalUserDataForm.get('selectedPeriod').value)?.year ?? null;
      let _contryId = (this.globalUserDataForm.get('selectedCountry').value)?.countryId ?? null;
      let _fromCurrency = (this.globalUserDataForm.get('selectedFromCurrency').value)?.valueId ?? null;
      let _toCurrency = (this.globalUserDataForm.get('selectedToCurrency').value)?.valueId ?? null;
      let _bankName = (this.globalUserDataForm.get('selectedBankName').value) ?? null;
      let _bankAccount = (this.globalUserDataForm.get('selectedBankAccount').value) ?? null;

      let req = {
        "id": {
          "storeId": _storeId,          //"0000000002",
          "year": _year,                //"2023",
          "countryId": _contryId,       // "ME",
          "currency": _fromCurrency,    //"USD",
          "currencyDest": _toCurrency,  //"MXN"
        },
        "status": "A",
        "bankName": _bankName,
        "bankAccout": _bankAccount
      };

      // LOG
      console.debug("Se guardará: ", req);

      // CALL API TO CREATE STORE CURRENCY
      const result = await this.tovpilCrudService.fetch(this.endPointCreateStoreCurrency, req);

      // EVALUATE RESPONSE TO MAKE ACTION
      if (result.success) {
        this.blocked = false;
        this.reloadGetStoreCurrencies();
      } else {
        this.blocked = false;
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (e) {
      this.blocked = false;
      console.error(e);
    }
  }
}
